import '../../publicPath';

import loadPolyfills from '../2-polyfill';

import { bootstrap as authBootstrap } from './auth';

(async () => {
  await loadPolyfills();
  await authBootstrap();
})();
